import axios from 'axios';

export default {
  login(credentials) {
    return axios.post('/auth/login', credentials).then((response) => {
      const { token } = response.data;
      this.setToken(token);
      return response.data;
    });
  },
  logout() {
    return axios.post('/auth/logout').then((response) => {
      return response;
    });
  },
  refresh() {
    axios.defaults.headers.common.Authorization = `Bearer ${window.localStorage.getItem('token')}`;
    return axios.post('http://api.michelepauty.com/api/auth/refresh').then((response) => {
      const { token } = response.data;
      this.setToken(token);
      return response.data;
    });
  },
  setToken(token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    window.localStorage.setItem('token', token);
  },
  validate() {
    axios.defaults.headers.common.Authorization = `Bearer ${window.localStorage.getItem('token')}`;
    // http://api.uther.com/api/auth/isvalide
    return axios.post('http://api.michelepauty.com/api/auth/isvalide').then((response) => {
    });
  }
};



// WEBPACK FOOTER //
// ./src/apis/auth-api.js